/**
 * Constants for oauth
 */

import { ICustomConfig } from '../types/interfaces'

const configKey = 'customConfig'
const customConfig = (configKey in window ? window.customConfig : {}) as ICustomConfig
const maintenanceOnBackendErrorKey = 'MAINTENANCE_ON_BACKEND_ERROR'

const clientScopeArr = [
  'openid',
  'profile',
  'contracts',
  'customers',
  'reports',
  'roles',
  'documents',
  'offline_access',
  'phone',
  'email',
  'orders',
  'locations',
  'notifications',
  'tags',
]

export class Constants {
  public static stsAuthority = customConfig.REACT_APP_AUTH_URL || import.meta.env.VITE_APP_AUTH_URL
  public static clientId =
    customConfig.REACT_APP_IDENTITY_CLIENT_ID || import.meta.env.VITE_APP_IDENTITY_CLIENT_ID
  public static clientRoot = location.origin
  public static clientScope = clientScopeArr.join(' ')
  public static documentEndpoint =
    customConfig.REACT_APP_DOCUMENT_URL || import.meta.env.VITE_APP_DOCUMENT_URL
  public static contractEndpoint =
    customConfig.REACT_APP_CONTRACT_URL || import.meta.env.VITE_APP_CONTRACT_URL
  public static locationsEndPoint =
    customConfig.REACT_APP_LOCATIONS_URL ||
    import.meta.env.VITE_APP_LOCATIONS_URL ||
    'https://locations-stg.interfleet.ch/api'
  public static customerEndpoint =
    customConfig.REACT_APP_CUSTOMER_URL || import.meta.env.VITE_APP_CUSTOMER_URL
  public static reportsEndpoint =
    customConfig.REACT_APP_REPORTS_URL || import.meta.env.VITE_APP_REPORTS_URL
  public static notificationsEndpoint =
    customConfig.REACT_APP_SUPPORT_URL ||
    import.meta.env.VITE_APP_SUPPORT_URL ||
    'https://notifications.interfleet.ch/api'
  public static ordersEndpoint =
    customConfig.REACT_APP_ORDERS_URL ||
    import.meta.env.VITE_APP_ORDERS_URL ||
    'https://orders-stg.interfleet.ch/api'
  public static maintenanceOnBackendError = (maintenanceOnBackendErrorKey in customConfig && !!customConfig.MAINTENANCE_ON_BACKEND_ERROR)
    ? customConfig[maintenanceOnBackendErrorKey]
    : import.meta.env[maintenanceOnBackendErrorKey] === 'true'
}
